import React, {useImperativeHandle, useRef} from "react";
import {useModel} from "../../../models";
import {DICT_KEY, getDictNameByCode} from "../../../utils/constants";

const borderStyle = {
    border: "1px double #000",
}

const PrintTitle = () => {
    return (
        <h3 style={{
            textAlign: "center",
            fontSize: "18pt",
            fontFamily: "楷体,楷体_GB2312",
        }}>
            采购退货单
        </h3>
    )
};
const PrintHeader = ({params: {returnCode, supplierId}}) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "1",
                textAlign: "left"
            }}>
                采购退货单号:<span style={{marginLeft: "12px"}}>{returnCode}</span>
            </div>
            <span style={{marginLeft: "12px"}}>
                {getDictNameByCode(DICT_KEY.CM_DICT.SUPPLIER, supplierId)}
            </span>
        </div>
    )
}

const PrintFooter = () => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "2",
                textAlign: "left"
            }}> 经办人:<span style={{marginLeft: "12px"}}> </span></div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}>操作员:<span style={{marginLeft: "12px"}}>主管</span></div>
        </div>
    )
}
const PrintTable = ({
                        params: {
                            mappedList,
                            discount,
                            roTotalNum,
                            receivableAmount
                        }
                    }) => {

    return (
        <table
            border="0"
            align="center"
            style={{
                borderCollapse: "collapse",
            }}
            width="100%"
        >
            <thead style={{display: "table-header-group",}}>
            <tr bgcolor="#d3d3d3">
                <th style={borderStyle}>配件编码</th>
                <th style={borderStyle}>配件名称</th>
                <th style={borderStyle}>图号</th>
                <th style={borderStyle}>数量</th>
                <th style={borderStyle}>含税单价</th>
                <th style={borderStyle}>含税金额</th>
            </tr>
            </thead>
            <tbody>
            {
                mappedList.map(el => (
                    <tr key={el.id}>
                        <td style={borderStyle}>{el.materialCode}</td>
                        <td style={borderStyle}>{el.materialName}</td>
                        <td style={borderStyle}>{el.replaceNum}</td>
                        <td style={borderStyle}>{el.returnNum}</td>
                        <td style={borderStyle}>{el.avgPrince}</td>
                        <td style={borderStyle}>{el.amount}</td>
                    </tr>))
            }
            <tr bgcolor="#d3d3d3">
                <td style={borderStyle} colSpan={6}>
                    <div style={{display: "flex"}}>
                        <div style={{
                            flex: "1",
                            textAlign: "left"
                        }}>
                            整单折扣:<span style={{marginLeft: "12px"}}>{discount}%</span>
                        </div>
                        <div
                            style={{
                                flex: "1",
                                textAlign: "left"
                            }}
                        >
                            退货总数量:<span style={{marginLeft: "12px"}}> {roTotalNum}</span>
                        </div>
                        <div
                            style={{
                                flex: "1",
                                textAlign: "left"
                            }}
                        >
                            应收金额: <span style={{marginLeft: "12px"}}>{receivableAmount}</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    )
}


export default ({printRef}) => {
    const ref = useRef();
    useImperativeHandle(printRef, () => ({
        dom: () => {
            return ref.current;
        },
    }));

    const [{
        selectedDocument: {returnCode, supplierId,},
        documentMaterialList,
        detailStatistics: {roTotalNum},
        formData
    },] = useModel("purchaseRo");
    const {receivableAmount = 0, discount = 100} = formData;
    const mappedList = documentMaterialList.map(el => {
        //平均价
        let avgPrince = el.receivableAmount / el.returnNum;
        if (!!!avgPrince) {
            avgPrince = 0
        }
        /*//上进位
        avgPrince = (Math.ceil(avgPrince * 100) / 100);
        const amount = Math.ceil(avgPrince * el.purchaseNum * 100) / 100;*/
        //四舍五入
        avgPrince = avgPrince.toFixed(2);
        const amount = (avgPrince * el.returnNum).toFixed(2);

        return {
            ...el,
            avgPrince,
            amount
        };
    });
    return (
        <div ref={ref} hidden={true}>
            <div style={{width: "800px", margin: "0 auto"}}>
                <PrintTitle/>
                <PrintHeader params={{returnCode, supplierId}}/>
                <PrintTable params={{
                    mappedList,
                    discount,
                    roTotalNum,
                    receivableAmount
                }}/>
                <PrintFooter/>
            </div>
        </div>
    )
}